export const REFERRAL_FORM_TEXT_MIN_LENGTH = 2;

export const REFERRAL_FIELD_PLACEHOLDERS = {
  referral_physician_name: 'Enter physician full name',
  diagnosis_date: 'Select diagnosis date',
  diagnosis_city: 'Enter city',
  diagnosis_state: 'Select state',
} as const;

export { DIAGNOSTIC_ASSESSMENT_OPTIONS as REFERRAL_DIAGNOSTIC_ASSESSMENT_OPTIONS } from '../../../../common/constants';

export const REFERRAL_DIAGNOSIS_OPTIONS = [
  { value: 'ASD', label: 'ASD' },
  {
    value: 'OTHER_DEVELOPMENTAL_DISORDERS',
    label: 'Other Developmental Disorders (eg. intellectual disabilities, language disorders)',
  },
  {
    value: 'MOOD_DISORDERS',
    label: 'Mood Disorders (eg. depression, bipolar disorder, anxiety disorders)',
  },
  { value: 'ADD or ADHD', label: 'ADD or ADHD' },
  { value: 'GDD', label: 'Global Developmental Delay' },
  { value: 'ODD', label: 'Oppositional Defiant Disorder' },
  {
    value: 'GENETIC_SYNDROME_ASD',
    label: 'Genetic Syndromes associated with ASD (eg. Fragile X Syndrome, Rett Syndrome)',
  },
  { value: 'Other', label: 'Other' },
] as const;

export const REFERRAL_REPORT_REQUIREMENTS = [
  'All pages of the diagnosis report',
  'Diagnosis of Autism Spectrum Disorder (ASD) OR Code - F84.0 (299.0)*',
  'Signed by MD, DO, PHD Psychologist, or PsycD',
  'Recommended level of Autism support (Level 1, 2, or 3)',
  'Recommendation for ABA therapy',
  'At least one standard psychiatric evaluation for autism',
  'Thorough background history (medical/family/educational)',
  'Developmental delays or regression documented',
  'Recent report written within the last 5 years',
  '*If Texas Medicaid: diagnosis date must be within the last 3 years',
] as const;
